import _WeakMap from "babel-runtime/core-js/weak-map";
export default function createInstanceScope() {
  var map = new _WeakMap();
  return function (context) {
    if (!map.has(context)) {
      map.set(context, {});
    }
    return map.get(context);
  };
}